import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiArrowLeft, FiTrash, FiDownload } from "react-icons/fi";
import UserHeader from "./UserHeader";
import Footer from "../Home/Footer";
import AxiosInstance from "../Home/AxiosInstance";
import profile from "../Home/Profile.png";
import "./Profile.css";
import "./employerPortal.css";
import {useTable, useGlobalFilter, useSortBy, useResizeColumns, usePagination,} from "react-table";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

export default function Profile() {
  const navigate = useNavigate();
  const BASE_MEDIA_URL = `${AxiosInstance.defaults.baseURL}media/`;
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    aliasName: "",
    email: "",
    mobileNo: "",
    dob: null,
    gender: null,
    about: "",
    imagePath: profile,
    address: [],
    educations: [],
    certifications: [],
    workExperiences: [],
    achievements: [],
    socialLinks: [],
  });
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(null);
  const [addressTypeOptions, setAddressTypeOptions] = useState([]);
  const [editingAddress, setEditingAddress] = useState(null);
  const [editedAddress, setEditedAddress] = useState(null);
  const [editAddressSearch, setEditAddressSearch] = useState("");
  const [editSuggestions, setEditSuggestions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [educationOptions, setEducationOptions] = useState([]);
  const [qualificationOptions, setQualificationOptions] = useState([]);
  const [editingEducation, setEditingEducation] = useState(null);
  const [editedEducation, setEditedEducation] = useState(null);
  const [certificationOptions, setCertificationOptions] = useState([]);
  const [editingCertification, setEditingCertification] = useState(null);
  const [editedCertification, setEditedCertification] = useState(null);
  const [roleOptions, setRoleOptions] = useState([]);
  const [editingWorkExperience, setEditingWorkExperience] = useState(null);
  const [editedWorkExperience, setEditedWorkExperience] = useState(null);
  const [editingAchievement, setEditingAchievement] = useState(null);
  const [editedAchievement, setEditedAchievement] = useState(null);
  const [achievementFilter, setAchievementFilter] = useState("");
  const [editingSocialLink, setEditingSocialLink] = useState(null);
  const [editedSocialLink, setEditedSocialLink] = useState(null);
  const [socialLinkFilter, setSocialLinkFilter] = useState("");
  const [addressFilter, setAddressFilter] = useState("");
  const [educationFilter, setEducationFilter] = useState("");
  const [certificationFilter, setCertificationFilter] = useState("");
  const [workExperienceFilter, setWorkExperienceFilter] = useState("");

  const handleDownloadPDF = () => {
    const input = document.getElementById("profile-content"); // ID of the container you want to export

    if (!input) {
      console.error("Profile content not found!");
      return;
    }

    html2canvas(input, {
      scale: 2, // Higher scale = better quality
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("profile_details.pdf");
    });
  };

  useEffect(() => {
    const fetchStatesAndCountries = async () => {
      try {
        console.log("Fetching countries...");
        const countriesResponse = await AxiosInstance.get(
          "companies/countries/"
        );
        setCountries(countriesResponse.data || []);

        if (country) {
          const statesResponse = await AxiosInstance.get(
            `companies/states/${country}/`
          );
          setStates(statesResponse.data || []);
        }
      } catch (error) {
        console.error("Error fetching states and countries:", error);
      }
    };

    fetchStatesAndCountries();
  }, [country]);

  useEffect(() => {
    const fetchAddressTypes = async () => {
      try {
        const response = await AxiosInstance.get("companies/address/types/");
        if (response.status === 200) {
          setAddressTypeOptions(response.data); // Set role options
        } else {
          console.error("Failed to fetch address types");
        }
      } catch (error) {
        console.error("Error fetching address types:", error);
      }
    };

    fetchAddressTypes();
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("User ID is missing. Please log in.");
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await AxiosInstance.get(
          `companies/user/details/${userId}/`
        );
        const userDetails = response.data;
        setUser((prevState) => ({
          ...prevState,
          firstName: userDetails.first_name || "Guest",
          lastName: userDetails.last_name || "User",
          aliasName: userDetails.alias_name,
          email: userDetails.email || "guest@example.com",
          mobileNo: userDetails.mobile_no || "",
          dob: userDetails.dob,
          gender: userDetails.gender,
          about: userDetails.about,
          imagePath: userDetails.image_path,
        }));
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("User ID is missing. Please log in.");
      return;
    }

    const fetchAddress = async () => {
      try {
        const addressResponse = await AxiosInstance.get(
          `companies/user/addresses/${userId}/`
        );
        setUser((prevState) => ({
          ...prevState,
          address: addressResponse.data || [],
        }));
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    };

    fetchAddress();
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("User ID is missing. Please log in.");
      return;
    }

    const fetchEducation = async () => {
      try {
        const educationResponse = await AxiosInstance.get(
          `companies/user/educations/${userId}/`
        );
        console.log("Education Response:", educationResponse.data);
        setUser((prevState) => ({
          ...prevState,
          educations: educationResponse.data || [],
        }));
      } catch (error) {
        console.error("Error fetching education:", error);
      }
    };

    fetchEducation();
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("User ID is missing. Please log in.");
      return;
    }

    const fetchCertifications = async () => {
      try {
        const certificationResponse = await AxiosInstance.get(
          `companies/user/certifications/${userId}/`
        );
        setUser((prevState) => ({
          ...prevState,
          certifications: certificationResponse.data || [],
        }));
      } catch (error) {
        console.error("Error fetching certifications:", error);
      }
    };

    fetchCertifications();
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("User ID is missing. Please log in.");
      return;
    }

    const fetchWorkExperience = async () => {
      try {
        const workExperienceResponse = await AxiosInstance.get(
          `companies/work-experiences/${userId}/`
        );
        setUser((prevState) => ({
          ...prevState,
          workExperiences: workExperienceResponse.data || [],
        }));
      } catch (error) {
        console.error("Error fetching work experience:", error);
      }
    };

    fetchWorkExperience();
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("User ID is missing. Please log in.");
      return;
    }

    const fetchAchievements = async () => {
      try {
        const achievementResponse = await AxiosInstance.get(
          `companies/user/achievements/${userId}/`
        );
        setUser((prevState) => ({
          ...prevState,
          achievements: achievementResponse.data || [],
        }));
      } catch (error) {
        console.error("Error fetching achievements:", error);
      }
    };

    fetchAchievements();
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("User ID is missing. Please log in.");
      return;
    }

    const fetchSocialLink = async () => {
      try {
        const socialLinkResponse = await AxiosInstance.get(
          `companies/user/social_link/${userId}`
        );
        setUser((prevState) => ({
          ...prevState,
          socialLinks: socialLinkResponse.data || [],
        }));
      } catch (error) {
        console.error("Error fetching social links:", error);
      }
    };

    fetchSocialLink();
  }, []);

  const navigatetoUpdateProfile = () => {
    navigate("/UpdateProfile", { state: { user } });
  };

  const handleAdd = (section) => {
    navigate(`/user-${section}`);
  };

  useEffect(() => {
    if (!editAddressSearch) {
      setEditSuggestions([]);
      return;
    }

    const timeout = setTimeout(async () => {
      try {
        const res = await AxiosInstance.get("companies/get-address/", {
          params: { address: editAddressSearch },
        });
        setEditSuggestions(res.data.suggestions || []);
      } catch (err) {
        console.error("Edit autocomplete failed", err);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [editAddressSearch]);

  const handleEditAddressSelect = async (placeId) => {
    setEditSuggestions([]);
    setEditAddressSearch("");

    try {
      const res = await AxiosInstance.get("companies/get-address-details/", {
        params: { placeId },
      });

      const data = res.data;

      const matchedCountry = countries.find(
        (c) => c.country_name === data.country
      );
      const matchedState = states.find((s) => s.state_name === data.state);

      setEditedAddress((prev) => ({
        ...prev,
        address_line1: data.addressLine1 || "",
        address_line2: data.addressLine2 || "",
        city: data.city || "",
        zip_code: data.postalCode || "",
        country: matchedCountry ? matchedCountry.country_id : "",
        state: matchedState ? matchedState.state_id : "",
      }));
    } catch (err) {
      console.error("Error fetching address details", err);
    }
  };

  const handleEditAddress = (index) => {
    const addressToEdit = user.address[index];
    setEditingAddress(addressToEdit);
    setEditedAddress({ ...addressToEdit });
  };

  const handleAddressInputChange = (e) => {
    const { name, value } = e.target;
    setEditedAddress({
      ...editedAddress,
      [name]: value,
    });
  };

  const handleCountryChange = (e) => {
    const countryId = e.target.value;
    setCountry(countryId); // Update the country state
    const selectedCountry = countries.find(
      (country) => country.country_id.toString() === countryId
    );

    // Update editedAddress state
    setEditedAddress({
      ...editedAddress,
      country: selectedCountry || null, // Set the full country object if needed
    });
  };

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    setEditedAddress({
      ...editedAddress,
      state: { state_id: stateId }, // Update the state ID in editedAddress
    });
  };

  const handleAddressTypeChange = (e) => {
    const addressTypeId = e.target.value;
    const selectedType = addressTypeOptions.find(
      (type) => type.address_type_id.toString() === addressTypeId
    );
    setEditedAddress({
      ...editedAddress,
      address_type: selectedType || null,
    });
  };

  const handleSaveAddress = async () => {
    if (!editedAddress.address_id) return;

    const payload = {
      ...editedAddress,
      country: editedAddress?.country?.country_id,
      state: editedAddress?.state?.state_id,
      address_type: editedAddress?.address_type?.address_type_id,
    };

    try {
      const response = await AxiosInstance.put(
        `companies/user/address/${editedAddress.address_id}/`,
        payload
      );

      // Use the full state object for immediate UI update
      const fullState = states.find(
        (s) => s.state_id.toString() === editedAddress.state.state_id.toString()
      );

      const updatedAddresses = user.address.map((address) =>
        address.address_id === editedAddress.address_id
          ? { ...editedAddress, state: fullState } // replace state with full object
          : address
      );

      setUser({ ...user, address: updatedAddresses });
      setEditingAddress(null);
    } catch (error) {
      console.error("Error saving address:", error);
    }
  };

  // Fetch education options from the API, including qualifications
  useEffect(() => {
    const fetchEducationOptions = async () => {
      try {
        const response = await AxiosInstance.get("companies/educations/");
        if (response.status === 200) {
          console.log("Fetched education options:", response.data);
          setEducationOptions(response.data);

          // Map qualifications with both 'education_id' and 'qualification'
          const qualifications = response.data.map((education) => ({
            education_id: education.education_id,
            qualification: education.qualification,
          }));
          setQualificationOptions(qualifications); // Store qualifications with IDs in state
        } else {
          setErrorMessage(
            "Failed to fetch education options. Please try again later."
          );
        }
      } catch (error) {
        console.error("Error fetching education options:", error);
        setErrorMessage(
          "Failed to fetch education options. Please try again later."
        );
      }
    };

    fetchEducationOptions();
  }, []);

  // Handle qualification change
  const handleQualificationChange = (e) => {
    const selectedQualification = qualificationOptions.find(
      (option) => option.qualification === e.target.value
    );

    setEditedEducation({
      ...editedEducation,
      education: selectedQualification || null, // Keep full object for display
    });
  };

  // Handle edit of education
  const handleEditEducation = (index) => {
    const educationToEdit = user.educations[index];
    setEditingEducation(educationToEdit);
    setEditedEducation({ ...educationToEdit });
  };

  // Handle input change in education fields
  const handleEducationInputChange = (e) => {
    const { name, value } = e.target;
    setEditedEducation({
      ...editedEducation,
      [name]: value,
    });
  };

  // Handle save of education data
  const handleSaveEducation = async () => {
    if (!editedEducation?.user_education_id) return;

    // Prepare payload: send only ID to backend
    const payload = {
      ...editedEducation,
      education: editedEducation.education
        ? editedEducation.education.education_id
        : "",
    };

    try {
      const response = await AxiosInstance.put(
        `companies/user-educations/${editedEducation.user_education_id}/`,
        payload
      );

      // Find full education object
      const fullEducation = educationOptions.find(
        (edu) => edu.education_id === response.data.education
      );

      // Update frontend state with full education object
      const updatedEducations = user.educations.map((education) =>
        education.user_education_id === editedEducation.user_education_id
          ? { ...response.data, education: fullEducation } // inject full object
          : education
      );

      setUser({ ...user, educations: updatedEducations });
      setEditingEducation(null);
    } catch (error) {
      console.error(
        "Error saving education:",
        error.response?.data || error.message
      );
    }
  };

  useEffect(() => {
    const fetchCertifications = async () => {
      try {
        const response = await AxiosInstance.get("companies/certifications/");
        if (response.status === 200) {
          console.log("Fetched certifications:", response.data);
          setCertificationOptions(response.data); // Assuming the response contains a list of certifications
        } else {
          setErrorMessage(
            "Failed to fetch certifications. Please try again later."
          );
        }
      } catch (error) {
        console.error("Error fetching certifications:", error);
        setErrorMessage(
          "Failed to fetch certifications. Please try again later."
        );
      }
    };

    fetchCertifications();
  }, []);

  // Handle editing a certification
  const handleEditCertification = (index) => {
    const certificationToEdit = user.certifications[index];
    setEditingCertification(certificationToEdit);
    setEditedCertification({ ...certificationToEdit });
  };

  // Handle certification selection
  const handleCertificationChange = (e) => {
    const certificationId = e.target.value; // Get the certification ID
    setEditedCertification({
      ...editedCertification,
      certification: certificationId, // Save the certification_id
    });
  };

  // Save edited certification
  const handleSaveCertification = async () => {
    try {
      // Prepare payload to send only the ID if your backend expects it
      const payload = {
        ...editedCertification,
        certification:
          typeof editedCertification.certification === "object"
            ? editedCertification.certification.certification_id
            : editedCertification.certification,
      };

      const response = await AxiosInstance.put(
        `companies/user-certifications/${editedCertification.user_certification_id}/`,
        payload
      );

      // Find the full certification object from your options
      const fullCertification = certificationOptions.find(
        (c) => c.certification_id === response.data.certification
      );

      // Update frontend state with the full object
      const updatedCertifications = user.certifications.map((certification) =>
        certification.user_certification_id ===
        editedCertification.user_certification_id
          ? {
              ...response.data,
              certification: fullCertification, // full object for component use
              certification_name: fullCertification.certification_name, // ensure UI updates instantly
            }
          : certification
      );

      setUser({ ...user, certifications: updatedCertifications });
      setEditingCertification(null);
    } catch (error) {
      console.error("Error saving certification:", error);
    }
  };

  // Fetch roles
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await AxiosInstance.get("companies/roles/");
        if (response.status === 200) {
          setRoleOptions(response.data);
        } else {
          console.error("Failed to fetch roles");
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();
  }, []);

  // Handle role selection
  const handleRoleChange = (e) => {
    const roleId = e.target.value;
    setEditedWorkExperience({
      ...editedWorkExperience,
      role: roleId,
    });
  };

  // Handle Edit Work Experience
  const handleEditWorkExperience = (index) => {
    const workExperienceToEdit = user.workExperiences[index];
    setEditingWorkExperience(workExperienceToEdit);

    setEditedWorkExperience({
      ...workExperienceToEdit,
      role: workExperienceToEdit.role.role_id,
    });
  };

  // Handle Saving the Edited Work Experience
  const handleSaveWorkExperience = async () => {
    try {
      const roleId =
        typeof editedWorkExperience.role === "object"
          ? editedWorkExperience.role.role_id
          : editedWorkExperience.role;

      const payload = {
        ...editedWorkExperience,
        role: roleId,
      };

      const response = await AxiosInstance.put(
        `companies/work/experiences/${editedWorkExperience.experience_id}/`,
        payload
      );

      // Get full role object for immediate UI update
      const fullRole = roleOptions.find((r) => r.role_id == roleId);

      const updatedExperience = {
        ...response.data,
        role: fullRole,
        role_name: fullRole.role_name,
      };

      const updatedWorkExperiences = user.workExperiences.map((exp) =>
        exp.experience_id === editedWorkExperience.experience_id
          ? updatedExperience
          : exp
      );

      setUser({ ...user, workExperiences: updatedWorkExperiences });
      setEditingWorkExperience(null);
    } catch (error) {
      console.error("Error saving work experience:", error);
    }
  };

  const handleEditAchievement = (index) => {
    const selectedAchievement = user.achievements[index];

    setEditingAchievement(selectedAchievement);
    setEditedAchievement({
      achievement_id: selectedAchievement.achievement_id,
      title: selectedAchievement.title || "",
      description: selectedAchievement.description || "",
      achievement_date: selectedAchievement.achievement_date || "",
      user: selectedAchievement.user,
      trainer: null,
    });
  };

  const handleSaveAchievement = async () => {
    console.log("Saving achievement:", editedAchievement);
    try {
      const response = await AxiosInstance.put(
        `companies/user-achievements/${editedAchievement.achievement_id}/`,
        {
          achievement_id: editedAchievement.achievement_id,
          title: editedAchievement.title,
          description: editedAchievement.description,
          achievement_date: editedAchievement.achievement_date,
          user: editedAchievement.user,
          trainer: null,
        }
      );
      console.log("PUT response:", response.status, response.data);

      if (response.status === 200) {
        const updatedAchievement = response.data;
        const updatedAchievements = user.achievements.map((achievement) =>
          achievement.achievement_id === updatedAchievement.achievement_id
            ? updatedAchievement
            : achievement
        );

        console.log("Re-mapped achievements:", updatedAchievements);

        setUser((prev) => ({
          ...prev,
          achievements: updatedAchievements,
        }));

        setEditingAchievement(null);
      }
    } catch (error) {
      console.error("Error updating achievement:", error);
    }
  };

  const handleEditSocialLink = (index) => {
    const selectedLink = user.socialLinks[index];

    // Set the current selection for UI editing
    setEditingSocialLink(selectedLink);

    // Flatten and prepare editable data (no nesting required)
    setEditedSocialLink({
      social_link_id: selectedLink.social_link_id,
      platform: selectedLink.platform || "",
      url: selectedLink.url || "",
      user: selectedLink.user, // required for PUT request
      trainer: null, // since this is a user link, set trainer to null
    });
  };

  const handleSaveSocialLink = async () => {
    console.log("Saving link:", editedSocialLink);
    try {
      const response = await AxiosInstance.put(
        `companies/user/social_link/${editedSocialLink.social_link_id}/`,
        {
          social_link_id: editedSocialLink.social_link_id,
          platform: editedSocialLink.platform,
          url: editedSocialLink.url,
          user: editedSocialLink.user,
          trainer: null,
        }
      );
      console.log("PUT response:", response.status, response.data);

      if (response.status === 200) {
        const updatedLink = response.data;
        const updatedLinks = user.socialLinks.map((link) =>
          link.social_link_id === updatedLink.social_link_id
            ? updatedLink
            : link
        );

        console.log("Re-mapped links:", updatedLinks);

        setUser((prev) => ({
          ...prev,
          socialLinks: updatedLinks,
        }));

        setEditingSocialLink(null);
      }
    } catch (error) {
      console.error("Error updating social link:", error);
    }
  };

  const handleRemoveAddress = async (index) => {
    const addressIdToRemove = user.address[index]?.address_id;

    if (!addressIdToRemove) {
      console.error("Address ID is missing.");
      return;
    }

    // Add confirmation window
    const isConfirmed = window.confirm(
      "Are you sure you want to remove this address?"
    );
    if (!isConfirmed) {
      console.log("Address removal canceled.");
      return;
    }

    try {
      // Send DELETE request to API to remove the address
      await AxiosInstance.delete(
        `companies/user-address/${addressIdToRemove}/`
      );

      // Remove the address from the local state
      const updatedAddresses = [...user.address];
      updatedAddresses.splice(index, 1); // Remove the address at the given index
      setUser((prevState) => ({
        ...prevState,
        address: updatedAddresses,
      }));

      console.log("Address removed successfully.");
    } catch (error) {
      console.error("Error removing address:", error);
    }
  };

  const handleRemoveEducation = async (index) => {
    const educationIdToRemove = user.educations[index]?.user_education_id;

    if (!educationIdToRemove) {
      console.error("User education ID is missing.");
      return;
    }

    // Add confirmation window
    const isConfirmed = window.confirm(
      "Are you sure you want to remove this education?"
    );
    if (!isConfirmed) {
      console.log("Education removal canceled.");
      return;
    }

    try {
      // Send DELETE request to API to remove the education
      const response = await AxiosInstance.delete(
        `companies/user-education/${educationIdToRemove}/`
      );
      console.log("Education removed successfully:", response.data);

      // Remove the education from the local state only after successful deletion
      const updatedEducation = [...user.educations];
      updatedEducation.splice(index, 1); // Remove the education at the given index
      setUser((prevState) => ({
        ...prevState,
        educations: updatedEducation,
      }));
    } catch (error) {
      console.error("Error removing education:", error);
    }
  };

  const handleRemoveCertification = async (index) => {
    const certificationIdToRemove =
      user.certifications[index]?.user_certification_id;

    if (!certificationIdToRemove) {
      console.error("Certification ID is missing.");
      return;
    }

    // Add confirmation window
    const isConfirmed = window.confirm(
      "Are you sure you want to remove this certification?"
    );
    if (!isConfirmed) {
      console.log("Certification removal canceled.");
      return;
    }

    try {
      // Send DELETE request to API to remove the certification
      const response = await AxiosInstance.delete(
        `companies/user-certification/${certificationIdToRemove}/`
      );
      console.log("Certification removed successfully:", response.data);

      // Remove the certification from the local state only after successful deletion
      const updatedCertifications = [...user.certifications];
      updatedCertifications.splice(index, 1); // Remove the certification at the given index
      setUser((prevState) => ({
        ...prevState,
        certifications: updatedCertifications,
      }));
    } catch (error) {
      console.error("Error removing certification:", error);
    }
  };

  const handleRemoveWorkExperience = async (index) => {
    const workExperienceIdToRemove = user.workExperiences[index]?.experience_id;

    if (!workExperienceIdToRemove) {
      console.error("Work Experience ID is missing.");
      return;
    }

    // Add confirmation window
    const isConfirmed = window.confirm(
      "Are you sure you want to remove this work experience?"
    );
    if (!isConfirmed) {
      console.log("Work experience removal canceled.");
      return;
    }

    try {
      // Send DELETE request to API to remove the work experience
      const response = await AxiosInstance.delete(
        `companies/work-experience/${workExperienceIdToRemove}/`
      );
      console.log("Work Experience removed successfully:", response.data);

      // Remove the work experience from the local state only after successful deletion
      const updatedWorkExperiences = [...user.workExperiences];
      updatedWorkExperiences.splice(index, 1); // Remove the work experience at the given index
      setUser((prevState) => ({
        ...prevState,
        workExperiences: updatedWorkExperiences,
      }));
    } catch (error) {
      console.error("Error removing work experience:", error);
    }
  };

  const handleRemoveAchievement = async (index) => {
    const achievementId = user.achievements[index]?.achievement_id;

    if (!achievementId) {
      console.error("Achievement ID missing.");
      return;
    }

    const isConfirmed = window.confirm(
      "Are you sure you want to remove this Achievement?"
    );
    if (!isConfirmed) return;

    try {
      await AxiosInstance.delete(
        `companies/user-achievement/${achievementId}/`
      );

      const updatedAchievements = user.achievements.filter(
        (achievement) => achievement.achievement_id !== achievementId
      );
      setUser((prev) => ({ ...prev, achievements: updatedAchievements }));
    } catch (error) {
      console.error("Error removing achievements:", error);
    }
  };

  const handleRemoveSocialLink = async (index) => {
    const linkId = user.socialLinks[index]?.social_link_id;

    if (!linkId) {
      console.error("Social Link ID missing.");
      return;
    }

    const isConfirmed = window.confirm(
      "Are you sure you want to remove this social link?"
    );
    if (!isConfirmed) return;

    try {
      await AxiosInstance.delete(`companies/user/social-link/${linkId}`);

      const updatedLinks = user.socialLinks.filter(
        (link) => link.social_link_id !== linkId
      );
      setUser((prev) => ({ ...prev, socialLinks: updatedLinks }));
    } catch (error) {
      console.error("Error removing social link:", error);
    }
  };

  // Table columns and data for address
  const addressColumns = React.useMemo(
    () => [
      { Header: "Address Line 1", accessor: "address_line1", resizable: true },
      { Header: "Address Line 2", accessor: "address_line2", resizable: true },
      { Header: "City", accessor: "city", resizable: true },
      { Header: "State", accessor: "state.state_name", resizable: true },
      { Header: "Country", accessor: "country.country_name", resizable: true },
      { Header: "Zip Code", accessor: "zip_code", resizable: true },
      {
        Header: "Address Type",
        accessor: "address_type.address_type",
        resizable: true,
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditAddress(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveAddress(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [user.address]
  );

  const addressTableInstance = useTable(
    {
      columns: addressColumns,
      data: user.address,
      initialState: { globalFilter: addressFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useResizeColumns
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state,
    setGlobalFilter,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    state: { pageIndex },
  } = addressTableInstance;

  const { globalFilter } = state;

  const educationColumns = React.useMemo(
    () => [
      { Header: "University Name", accessor: "university", resizable: true },
      { Header: "College Name", accessor: "college_name", resizable: true },
      {
        Header: "Qualification",
        accessor: "education.qualification",
        resizable: true,
      },
      { Header: "Specialization", accessor: "specialization", resizable: true },
      {
        Header: "Year Of Starting",
        accessor: "year_of_starting",
        resizable: true,
      },
      {
        Header: "Year Of Passing",
        accessor: "year_of_passing",
        resizable: true,
      },
      {
        Header: "Percentage/CGPA",
        accessor: "percentage_or_cgpa",
        resizable: true,
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditEducation(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveEducation(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [user.educations]
  );

  const educationTableInstance = useTable(
    {
      columns: educationColumns,
      data: user.educations, // Make sure user.educations is an array
      initialState: { globalFilter: educationFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useResizeColumns,
    useSortBy,
    usePagination
  );

  // Rename the variables for the education table to avoid conflict
  const {
    getTableProps: getEducationTableProps,
    getTableBodyProps: getEducationTableBodyProps,
    headerGroups: educationHeaderGroups,
    prepareRow: prepareEducationRow,
    page: educationPage,
    state: { pageIndex: educationPageIndex },
    nextPage: nextEducationPage,
    previousPage: previousEducationPage,
    canNextPage: canNextEducationPage,
    canPreviousPage: canPreviousEducationPage,
    setGlobalFilter: setEducationGlobalFilter,
  } = educationTableInstance;

  const certificationColumns = React.useMemo(
    () => [
      {
        Header: "Certification Name",
        accessor: "certification_name",
        resizable: true,
      },
      {
        Header: "Issue Authority ",
        accessor: "issue_authority",
        resizable: true,
      },
      { Header: "Issue Date", accessor: "issue_date", resizable: true },
      { Header: "Expiry Date", accessor: "expiry_date", resizable: true },
      {
        Header: "Certificate Path",
        accessor: "certificate_path",
        resizable: true,
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditCertification(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveCertification(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [user.certifications]
  );

  const certificationTableInstance = useTable(
    {
      columns: certificationColumns,
      data: user.certifications,
      initialState: { globalFilter: certificationFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useResizeColumns,
    useSortBy,
    usePagination
  );

  const {
    getTableProps: getCertificationTableProps,
    getTableBodyProps: getCertificationTableBodyProps,
    headerGroups: certificationHeaderGroups,
    prepareRow: prepareCertificationRow,
    page: certificationPage,
    state: { pageIndex: certificationPageIndex },
    nextPage: nextCertificationPage,
    previousPage: previousCertificationPage,
    canNextPage: canNextCertificationPage,
    canPreviousPage: canPreviousCertificationPage,
    setGlobalFilter: setCertificationGlobalFilter,
  } = certificationTableInstance;

  const workExperienceColumns = React.useMemo(
    () => [
      { Header: "Company Name", accessor: "company_name", resizable: true },
      { Header: "Designation", accessor: "role.role", resizable: true },
      { Header: "Experience", accessor: "experience", resizable: true },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditWorkExperience(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveWorkExperience(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [user.workExperiences]
  );

  const workExperienceTableInstance = useTable(
    {
      columns: workExperienceColumns,
      data: user.workExperiences,
      initialState: { globalFilter: workExperienceFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useResizeColumns,
    useSortBy,
    usePagination
  );

  const {
    getTableProps: getWorkExperienceTableProps,
    getTableBodyProps: getWorkExperienceTableBodyProps,
    headerGroups: workExperienceHeaderGroups,
    prepareRow: prepareWorkExperienceRow,
    page: workExperiencePage,
    state: { pageIndex: workExperiencePageIndex },
    nextPage: nextWorkExperiencePage,
    previousPage: previousWorkExperiencePage,
    canNextPage: canNextWorkExperiencePage,
    canPreviousPage: canPreviousWorkExperiencePage,
    setGlobalFilter: setWorkExperienceGlobalFilter,
  } = workExperienceTableInstance;

  const achievementColumns = React.useMemo(
    () => [
      { Header: "Title", accessor: "title", resizable: true },
      { Header: "Description", accessor: "description", resizable: true },
      {
        Header: "Achievement Date",
        accessor: "achievement_date",
        resizable: true,
      },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditAchievement(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveAchievement(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [user.achievements]
  );

  const achievementTableInstance = useTable(
    {
      columns: achievementColumns,
      data: user.achievements,
      initialState: { globalFilter: achievementFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useResizeColumns,
    useSortBy,
    usePagination
  );

  const {
    getTableProps: getAchievementTableProps,
    getTableBodyProps: getAchievementTableBodyProps,
    headerGroups: achievementHeaderGroups,
    prepareRow: prepareAchievementRow,
    page: achievementPage,
    state: { pageIndex: achievementPageIndex },
    nextPage: nextAchievementPage,
    previousPage: previousAchievementPage,
    canNextPage: canNextAchievementPage,
    canPreviousPage: canPreviousAchievementPage,
    setGlobalFilter: setAchievementGlobalFilter,
  } = achievementTableInstance;

  const socialLinkColumns = React.useMemo(
    () => [
      { Header: "Platform", accessor: "platform", resizable: true },
      { Header: "URL", accessor: "url", resizable: true },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditSocialLink(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveSocialLink(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [user.socialLinks]
  );

  const socialLinkTableInstance = useTable(
    {
      columns: socialLinkColumns,
      data: user.socialLinks,
      initialState: { globalFilter: socialLinkFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useResizeColumns,
    useSortBy,
    usePagination
  );

  const {
    getTableProps: getSocialLinkTableProps,
    getTableBodyProps: getSocialLinkTableBodyProps,
    headerGroups: socialLinkHeaderGroups,
    prepareRow: prepareSocialLinkRow,
    page: socialLinkPage,
    state: { pageIndex: socialLinkPageIndex },
    nextPage: nextSocialLinkPage,
    previousPage: previousSocialLinkPage,
    canNextPage: canNextSocialLinkPage,
    canPreviousPage: canPreviousSocialLinkPage,
    setGlobalFilter: setSocialLinkGlobalFilter,
  } = socialLinkTableInstance;

  return (
    <div className="CompanyPage als-employer-page">
      <UserHeader />
      <div className="company-container py-4">
        {/* Profile Info */}
        {/* Custom Navigation Path Button */}
        <div className="navigation-btn-container d-flex justify-content-between align-items-center mb-3">
          <button
            className="btn btn-outline-primary d-flex align-items-center"
            onClick={() => navigate("/user-profile")}
            style={{ gap: "6px" }}
          >
            <FiArrowLeft /> Back
          </button>

          {/* <button
    onClick={handleDownloadPDF}
    className="btn btn-outline-success d-flex align-items-center"
    style={{ gap: "6px" }}
  >
    <FiDownload /> Download
  </button> */}
        </div>
        <div id="profile-content">
          {/* PERSONAL DETAILS */}
          <h2 className="section-heading">Personal Details:</h2>
          <div className="card-custom p-4">
            {/* Image + Details Side-by-Side */}
            <div className="d-flex flex-wrap gap-4 align-items-start">
              {/* Profile Image */}
              <div>
                <img
                  src={
                    user.imagePath
                      ? `${BASE_MEDIA_URL}${user.imagePath.replace(/\\/g, "/")}`
                      : profile
                  }
                  alt="Profile"
                  className="profile-image"
                  style={{
                    width: "180px",
                    height: "180px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
              </div>

              {/* User Details */}
              <div className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-start">
                  <p>
                    <strong>Name:</strong> {user.firstName} {user.lastName}
                  </p>
                  <button
                    onClick={navigatetoUpdateProfile}
                    className="btn btn-sm btn-outline-primary"
                  >
                    <FiEdit />
                  </button>
                </div>
                <p>
                  <strong>Alias Name:</strong> {user.aliasName || ""}
                </p>
                <p>
                  <strong>Email:</strong> {user.email}
                </p>
                <p>
                  <strong>Mobile Number:</strong> {user.mobileNo}
                </p>
                <p>
                  <strong>Date Of Birth:</strong> {user.dob}
                </p>
                <p>
                  <strong>Gender:</strong> {user.gender}
                </p>
              </div>
            </div>

            {/* About Section */}
            <div className="mt-4">
              <strong>About:</strong>
              {user.about ? (
                (() => {
                  // Split lines and check if any line starts with bullet
                  const lines = user.about
                    .split("\n")
                    .filter((line) => line.trim() !== "");
                  const hasBullets = lines.some(
                    (line) =>
                      line.trim().startsWith("- ") ||
                      line.trim().startsWith("* ")
                  );

                  if (hasBullets) {
                    // Render as bullet list, stripping bullet chars
                    return (
                      <ul>
                        {lines.map((line, index) => {
                          const trimmed = line.trim();
                          if (
                            trimmed.startsWith("- ") ||
                            trimmed.startsWith("* ")
                          ) {
                            return (
                              <li key={index}>{trimmed.substring(2).trim()}</li>
                            );
                          }
                          // If some lines don't start with bullet but others do, still show them as list items
                          return <li key={index}>{trimmed}</li>;
                        })}
                      </ul>
                    );
                  } else {
                    // Render as paragraphs
                    return lines.map((line, index) => (
                      <p key={index}>{line}</p>
                    ));
                  }
                })()
              ) : (
                <p>No description provided.</p>
              )}
            </div>
          </div>

          {/* Address Section */}
          <h2 className="section-heading">Addresses:</h2>
          <div className="card-custom">
            <div className="d-flex justify-content-between mb-3">
              <input
                type="text"
                className="form-control w-50"
                value={addressFilter || ""}
                onChange={(e) => {
                  setAddressFilter(e.target.value);
                  setGlobalFilter(e.target.value);
                }}
                placeholder="Search addresses..."
              />
              <button
                className="add-button"
                onClick={() => handleAdd("address")}
              >
                Add
              </button>
            </div>
            <div className="table-responsive">
              <table
                className="table table-bordered table-striped"
                {...getTableProps()}
              >
                <thead className="table-light">
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " ▼"
                                : " ▲"
                              : ""}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {user.address.length === 0 ? (
                    <tr>
                      <td colSpan={8}>No addresses found</td>
                    </tr>
                  ) : (
                    page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
              <div className="pagination d-flex align-items-center gap-2 mt-3">
                <button
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Previous
                </button>
                <span>
                  Page <strong>{pageIndex + 1}</strong> of{" "}
                  <strong>{pageOptions.length}</strong>
                </span>
                <button
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>
            {editingAddress && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Address</h5>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="mb-3 position-relative">
                          <label className="form-label">Search Address</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Type address..."
                            value={editAddressSearch}
                            onChange={(e) =>
                              setEditAddressSearch(e.target.value)
                            }
                          />
                          {editSuggestions.length > 0 && (
                            <ul
                              className="list-group position-absolute w-100"
                              style={{ zIndex: 999 }}
                            >
                              {editSuggestions.map((item, idx) => (
                                <li
                                  key={idx}
                                  className="list-group-item list-group-item-action"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleEditAddressSelect(item.place_id)
                                  }
                                >
                                  {item.description}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Address Line 1</label>
                            <input
                              type="text"
                              className="form-control"
                              name="address_line1"
                              value={editedAddress?.address_line1 || ""}
                              onChange={handleAddressInputChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Address Line 2</label>
                            <input
                              type="text"
                              className="form-control"
                              name="address_line2"
                              value={editedAddress?.address_line2 || ""}
                              onChange={handleAddressInputChange}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">City</label>
                            <input
                              type="text"
                              className="form-control"
                              name="city"
                              value={editedAddress?.city || ""}
                              onChange={handleAddressInputChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Zip Code</label>
                            <input
                              type="text"
                              className="form-control"
                              name="zip_code"
                              value={editedAddress?.zip_code || ""}
                              onChange={handleAddressInputChange}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Country</label>
                            <select
                              className="form-select"
                              name="country"
                              value={editedAddress?.country?.country_id || ""}
                              onChange={handleCountryChange}
                            >
                              <option value="">Select Country</option>
                              {countries.map((country) => (
                                <option
                                  key={country.country_id}
                                  value={country.country_id}
                                >
                                  {country.country_name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">State</label>
                            <select
                              className="form-select"
                              name="state"
                              value={editedAddress?.state?.state_id || ""}
                              onChange={handleStateChange}
                              disabled={!country}
                            >
                              <option value="">Select State</option>
                              {states.map((state) => (
                                <option
                                  key={state.state_id}
                                  value={state.state_id}
                                >
                                  {state.state_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Address Type</label>
                          <select
                            className="form-select"
                            name="address_type"
                            value={
                              editedAddress?.address_type?.address_type_id || ""
                            }
                            onChange={handleAddressTypeChange}
                          >
                            <option value="">Select Address Type</option>
                            {addressTypeOptions.map((type) => (
                              <option
                                key={type.address_type_id}
                                value={type.address_type_id}
                              >
                                {type.address_type}
                              </option>
                            ))}
                          </select>
                        </div>
                      </form>
                    </div>
                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setEditingAddress(null)}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleSaveAddress}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Education Section */}
          <h2 className="section-heading">Educations:</h2>
          <div className="card-custom">
            <div className="d-flex justify-content-between mb-3">
              <input
                type="text"
                className="form-control w-50"
                value={educationFilter || ""}
                onChange={(e) => {
                  setEducationFilter(e.target.value);
                  setEducationGlobalFilter(e.target.value);
                }}
                placeholder="Search educations..."
              />
              <button
                className="add-button"
                onClick={() => handleAdd("educations")}
              >
                Add
              </button>
            </div>
            <div className="table-responsive">
              <table
                className="table table-bordered table-striped"
                {...getEducationTableProps()}
              >
                <thead className="table-light">
                  {educationHeaderGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " ▼"
                                : " ▲"
                              : ""}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getEducationTableBodyProps()}>
                  {user.educations.length === 0 ? (
                    <tr>
                      <td colSpan={8}>No educations found</td>
                    </tr>
                  ) : (
                    educationPage.map((row) => {
                      prepareEducationRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
              <div className="pagination d-flex align-items-center gap-2 mt-3">
                <button
                  onClick={() => previousEducationPage()}
                  disabled={!canPreviousEducationPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Previous
                </button>
                <span>
                  Page <strong>{educationPageIndex + 1}</strong> of{" "}
                  <strong>{educationTableInstance.pageOptions.length}</strong>
                </span>
                <button
                  onClick={() => nextEducationPage()}
                  disabled={!canNextEducationPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>
            {editingEducation && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Education</h5>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="mb-3">
                          <label className="form-label">University Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="university"
                            value={editedEducation?.university || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">College Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="college_name"
                            value={editedEducation?.college_name || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Qualification</label>
                            <select
                              className="form-select"
                              name="education"
                              value={
                                editedEducation?.education?.qualification || ""
                              }
                              onChange={handleQualificationChange}
                            >
                              <option value="">Select Qualification</option>
                              {qualificationOptions.map((option) => (
                                <option
                                  key={option.education_id}
                                  value={option.qualification}
                                >
                                  {option.qualification}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Specialization</label>
                            <input
                              type="text"
                              className="form-control"
                              name="specialization"
                              value={editedEducation?.specialization || ""}
                              onChange={handleEducationInputChange}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Year of Starting
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="year_of_starting"
                              value={editedEducation?.year_of_starting || ""}
                              onChange={handleEducationInputChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Year of Passing
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="year_of_passing"
                              value={editedEducation?.year_of_passing || ""}
                              onChange={handleEducationInputChange}
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Percentage/CGPA</label>
                          <input
                            type="text"
                            className="form-control"
                            name="percentage_or_cgpa"
                            value={editedEducation?.percentage_or_cgpa || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                      </form>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setEditingEducation(null)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSaveEducation}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Certification Section */}
          <h2 className="section-heading">Certifications:</h2>
          <div className="card-custom">
            <div className="d-flex justify-content-between mb-3">
              <input
                type="text"
                className="form-control w-50"
                value={certificationFilter || ""}
                onChange={(e) => {
                  setCertificationFilter(e.target.value);
                  setCertificationGlobalFilter(e.target.value);
                }}
                placeholder="Search certification records..."
              />
              <button
                className="add-button"
                onClick={() => handleAdd("certifications")}
              >
                Add
              </button>
            </div>
            <div className="table-responsive">
              <table
                className="table table-bordered table-striped"
                {...getCertificationTableProps()}
              >
                <thead classname="table-light">
                  {certificationHeaderGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " ▼"
                                : " ▲"
                              : ""}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getCertificationTableBodyProps()}>
                  {user.certifications.length === 0 ? (
                    <tr>
                      <td colSpan={8}>No certifications found</td>
                    </tr>
                  ) : (
                    certificationPage.map((row) => {
                      prepareCertificationRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
              <div className="pagination d-flex align-items-center gap-2 mt-3">
                <button
                  onClick={() => previousCertificationPage()}
                  disabled={!canPreviousCertificationPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Previous
                </button>
                <span>
                  Page <strong>{certificationPageIndex + 1}</strong> of{" "}
                  <strong>
                    {certificationTableInstance.pageOptions.length}
                  </strong>
                </span>
                <button
                  onClick={() => nextCertificationPage()}
                  disabled={!canNextCertificationPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>
            {editingCertification && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Certification</h5>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="mb-3">
                          <label className="form-label">Certification</label>
                          <select
                            className="form-select"
                            name="certification"
                            value={
                              typeof editedCertification?.certification ===
                              "object"
                                ? editedCertification.certification
                                    .certification_id
                                : editedCertification?.certification || ""
                            }
                            onChange={handleCertificationChange}
                          >
                            <option value="">Select Certification</option>
                            {certificationOptions.map((certification) => (
                              <option
                                key={certification.certification_id}
                                value={certification.certification_id}
                              >
                                {certification.certification_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Issue Authority</label>
                          <input
                            type="text"
                            className="form-control"
                            name="issue_authority"
                            value={editedCertification?.issue_authority || ""}
                            onChange={(e) =>
                              setEditedCertification({
                                ...editedCertification,
                                issue_authority: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Issue Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="issue_date"
                              value={editedCertification?.issue_date || ""}
                              onChange={(e) =>
                                setEditedCertification({
                                  ...editedCertification,
                                  issue_date: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Expiry Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="expiry_date"
                              value={editedCertification?.expiry_date || ""}
                              onChange={(e) =>
                                setEditedCertification({
                                  ...editedCertification,
                                  expiry_date: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Certificate Path</label>
                          <input
                            type="text"
                            className="form-control"
                            name="certificate_path"
                            value={editedCertification?.certificate_path || ""}
                            onChange={(e) =>
                              setEditedCertification({
                                ...editedCertification,
                                certificate_path: e.target.value,
                              })
                            }
                          />
                        </div>
                      </form>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setEditingCertification(null)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSaveCertification}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Experience Section */}
          <h2 className="section-heading">Work Experiences:</h2>
          <div className="card-custom">
            <div className="d-flex justify-content-between mb-3">
              <input
                type="text"
                className="form-control w-50"
                value={workExperienceFilter || ""}
                onChange={(e) => {
                  setWorkExperienceFilter(e.target.value);
                  setWorkExperienceGlobalFilter(e.target.value);
                }}
                placeholder="Search work experiences..."
              />
              <button
                className="add-button"
                onClick={() => handleAdd("workExperiences")}
              >
                Add
              </button>
            </div>
            <div className="table-responsive">
              <table
                className="table table-bordered table-striped"
                {...getWorkExperienceTableProps()}
              >
                <thead classname="table-light">
                  {workExperienceHeaderGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " ▼"
                                : " ▲"
                              : ""}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getWorkExperienceTableBodyProps()}>
                  {user.workExperiences.length === 0 ? (
                    <tr>
                      <td colSpan={4}>No work experiences found</td>
                    </tr>
                  ) : (
                    workExperiencePage.map((row) => {
                      prepareWorkExperienceRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
              <div className="pagination d-flex align-items-center gap-2 mt-3">
                <button
                  onClick={() => previousWorkExperiencePage()}
                  disabled={!canPreviousWorkExperiencePage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Previous
                </button>
                <span>
                  Page <strong>{workExperiencePageIndex + 1}</strong> of{" "}
                  <strong>
                    {workExperienceTableInstance.pageOptions.length}
                  </strong>
                </span>
                <button
                  onClick={() => nextWorkExperiencePage()}
                  disabled={!canNextWorkExperiencePage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>
            {editingWorkExperience && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-md modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Work Experience</h5>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="mb-3">
                          <label className="form-label">Company Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="company_name"
                            value={editedWorkExperience?.company_name || ""}
                            onChange={(e) =>
                              setEditedWorkExperience({
                                ...editedWorkExperience,
                                company_name: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Role</label>
                          <select
                            className="form-select"
                            name="role"
                            value={
                              typeof editedWorkExperience.role === "object"
                                ? editedWorkExperience.role.role_id
                                : editedWorkExperience.role || ""
                            }
                            onChange={handleRoleChange}
                          >
                            <option value="">Select a role</option>
                            {roleOptions.map((role) => (
                              <option key={role.role_id} value={role.role_id}>
                                {role.role}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Experience</label>
                          <input
                            type="text"
                            className="form-control"
                            name="experience"
                            value={editedWorkExperience?.experience || ""}
                            onChange={(e) =>
                              setEditedWorkExperience({
                                ...editedWorkExperience,
                                experience: e.target.value,
                              })
                            }
                          />
                        </div>
                      </form>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setEditingWorkExperience(null)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSaveWorkExperience}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Achievements Section */}
          <h2 className="section-heading">Achievements:</h2>
          <div className="card-custom">
            <div className="d-flex justify-content-between mb-3">
              <input
                type="text"
                className="form-control w-50"
                value={achievementFilter || ""}
                onChange={(e) => {
                  setAchievementFilter(e.target.value);
                  setAchievementGlobalFilter(e.target.value);
                }}
                placeholder="Search achievements..."
              />
              <button
                className="add-button"
                onClick={() => handleAdd("achievements")}
              >
                Add
              </button>
            </div>

            <div className="table-responsive">
              <table
                className="table table-bordered table-striped"
                {...getAchievementTableProps()}
              >
                <thead className="table-light">
                  {achievementHeaderGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " ▼"
                                : " ▲"
                              : ""}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getAchievementTableBodyProps()}>
                  {user.achievements.length === 0 ? (
                    <tr>
                      <td colSpan={4}>No achievements found</td>
                    </tr>
                  ) : (
                    achievementPage.map((row) => {
                      prepareAchievementRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>

              <div className="pagination d-flex align-items-center gap-2 mt-3">
                <button
                  onClick={() => previousAchievementPage()}
                  disabled={!canPreviousAchievementPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Previous
                </button>
                <span>
                  Page <strong>{achievementPageIndex + 1}</strong> of{" "}
                  <strong>{achievementTableInstance.pageOptions.length}</strong>
                </span>
                <button
                  onClick={() => nextAchievementPage()}
                  disabled={!canNextAchievementPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>

            {editingAchievement && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-md modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Achievement</h5>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="mb-3">
                          <label className="form-label">Title</label>
                          <input
                            type="text"
                            className="form-control"
                            value={editedAchievement?.title || ""}
                            onChange={(e) =>
                              setEditedAchievement({
                                ...editedAchievement,
                                title: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Description</label>
                          <input
                            type="text"
                            className="form-control"
                            value={editedAchievement?.description || ""}
                            onChange={(e) =>
                              setEditedAchievement({
                                ...editedAchievement,
                                description: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Achievement Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={editedAchievement?.achievement_date || ""}
                            onChange={(e) =>
                              setEditedAchievement({
                                ...editedAchievement,
                                achievement_date: e.target.value,
                              })
                            }
                          />
                        </div>
                      </form>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setEditingAchievement(null)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSaveAchievement}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Social Links Section */}
          <h2 className="section-heading">Social Links:</h2>
          <div className="card-custom">
            <div className="d-flex justify-content-between mb-3">
              <input
                type="text"
                className="form-control w-50"
                value={socialLinkFilter || ""}
                onChange={(e) => {
                  setSocialLinkFilter(e.target.value);
                  setSocialLinkGlobalFilter(e.target.value);
                }}
                placeholder="Search social links..."
              />
              <button
                className="add-button"
                onClick={() => handleAdd("socialLinks")}
              >
                Add
              </button>
            </div>

            <div className="table-responsive">
              <table
                className="table table-bordered table-striped"
                {...getSocialLinkTableProps()}
              >
                <thead className="table-light">
                  {socialLinkHeaderGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " ▼"
                                : " ▲"
                              : ""}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getSocialLinkTableBodyProps()}>
                  {user.socialLinks.length === 0 ? (
                    <tr>
                      <td colSpan={3}>No social links found</td>
                    </tr>
                  ) : (
                    socialLinkPage.map((row) => {
                      prepareSocialLinkRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>

              <div className="pagination d-flex align-items-center gap-2 mt-3">
                <button
                  onClick={() => previousSocialLinkPage()}
                  disabled={!canPreviousSocialLinkPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Previous
                </button>
                <span>
                  Page <strong>{socialLinkPageIndex + 1}</strong> of{" "}
                  <strong>{socialLinkTableInstance.pageOptions.length}</strong>
                </span>
                <button
                  onClick={() => nextSocialLinkPage()}
                  disabled={!canNextSocialLinkPage}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>

            {editingSocialLink && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-md modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Social Link</h5>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="mb-3">
                          <label className="form-label">Platform</label>
                          <input
                            type="text"
                            className="form-control"
                            value={editedSocialLink?.platform || ""}
                            onChange={(e) =>
                              setEditedSocialLink({
                                ...editedSocialLink,
                                platform: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">URL</label>
                          <input
                            type="url"
                            className="form-control"
                            value={editedSocialLink?.url || ""}
                            onChange={(e) =>
                              setEditedSocialLink({
                                ...editedSocialLink,
                                url: e.target.value,
                              })
                            }
                          />
                        </div>
                      </form>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setEditingSocialLink(null)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSaveSocialLink}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
